'use strict';

/**
 * User Service
 */
module.service('userService', [ 'Restangular', '$q', function(Restangular, $q) {

    /*
     * ------------------------------------------------------------------------------
     * SERVICE FUNCTIONS
     * -------------------------------------------------------------------------------
     */
    var userResource = Restangular.all('user');

    return {

        searchUsers : function(filters) {
            var deferred = $q.defer();
            var answer = new restResponse();

            userResource.customGET('', filters).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        searchAll : function(filters) {
            var deferred = $q.defer();
            var answer = new restResponse();

            userResource.customGET('all', filters).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        loadUser : function(id) {
            var deferred = $q.defer();
            var answer = new restResponse();
            userResource.get(id).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        asignUserAsLegalRep: function(idUser){
        	var deferred = $q.defer();
            var answer = new restResponse();
            userResource.customPUT(null, idUser + '/assignceo').then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        

        updateUser : function(id, user) {
            var deferred = $q.defer();
            var answer = new restResponse();
            Restangular.one('user', id).customPUT(user).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        createUser : function(createModel) {
            var deferred = $q.defer();
            var answer = new restResponse();
            userResource.customPOST(createModel).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        modifyUserStatus : function(id, status) {
            var deferred = $q.defer();
            var answer = new restResponse();
            Restangular.one('user', id).one('status', status).customPUT().then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        updateRoles : function(id, roles) {
            var deferred = $q.defer();
            var answer = new restResponse();
            Restangular.one('user', id).customPUT(roles, 'roles').then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        updateUserProfile : function(id, model) {
            var deferred = $q.defer();
            var answer = new restResponse();
            var user = {};
            user.active = false;
            Restangular.one('user', id).customPUT(model, 'profile').then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        getSignature : function() {
            var deferred = $q.defer();
            var answer = new restResponse();
            Restangular.all("user").customGET("sign").then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        updateSignature : function(model) {
            var deferred = $q.defer();
            var answer = new restResponse();
            userResource.customPUT(model, 'sign').then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
    };
} ]);